import _ from "lodash";
import React, { useState } from "react";
import { Button } from "@toddle-edu/ds-web";
import {
  ArrowLeftPaneOutlined,
  ArrowRightPaneOutlined,
} from "@toddle-edu/ds-icons";
import QuestionDetailsSideBar from "Worksheet/components/QuestionDetailsSideBar/QuestionDetailsSideBar";
import { connect } from "react-redux";
import { getUserType } from "modules/CommonSelectors";
import classes from "./ShowQuestionDetail.scss";

const ShowQuestionDetail = ({
  t,
  config,
  userType,
  worksheetMode,
  isFromInternalTool,
  isQueriesV2Enabled,
}) => {
  const [viewQuestionDetail, setViewQuestionDetail] = useState(false);

  const btnIcon = viewQuestionDetail ? (
    <ArrowRightPaneOutlined />
  ) : (
    <ArrowLeftPaneOutlined />
  );

  const hideButtonContent = window.innerWidth < 670;

  return (
    <>
      <Button
        type="outlined"
        dsVersion="2.0"
        variant="neutral"
        onClick={() => setViewQuestionDetail(!viewQuestionDetail)}
        icon={btnIcon}
        className={classes.questionDetailButton}
      >
        {!hideButtonContent &&
          (viewQuestionDetail
            ? t("common:hide_with_label", { label: t("common:question") })
            : t("workbook:view_question"))}
      </Button>

      {viewQuestionDetail && (
        <QuestionDetailsSideBar
          t={t}
          userType={userType}
          isFullScreenHeight={true}
          worksheetMode={worksheetMode}
          viewQuestion={viewQuestionDetail}
          localeLabel="worksheet:video_response"
          isFromInternalTool={isFromInternalTool}
          setViewQuestion={setViewQuestionDetail}
          questionId={_.get(config, "questionId", "")}
          resourceId={_.get(config, "resourceId", null)}
          questionIndex={_.get(config, "questionIndex", 0)}
          isSubQuestion={_.get(config, "isSubQuestion", false)}
          subQuestionParentId={_.get(config, "subQuestionParentId", null)}
          isQueriesV2Enabled={isQueriesV2Enabled}
        />
      )}
    </>
  );
};

const mapStateToProps = state => {
  const userType = getUserType(state);
  return { userType };
};

export default connect(mapStateToProps, null)(ShowQuestionDetail);
